// extracted by mini-css-extract-plugin
export default {"FieldAccordionDraggableWrapper":"FieldAccordionDraggableWrapper---Hn1SG","FieldAccordionDraggableWrapper--dragging":"FieldAccordionDraggableWrapper--dragging---rU4Mm"};